'use client';
import { CookieConsent } from 'react-cookie-consent';
import {
  Button,
  getContrastRatio,
  GlobalStyles,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslate } from '@jd/i18n';
import RichI18n from '../RichI18n';
import { FooterProps } from '../mainLayout/footer/types';
import RichText from '../RichText';

type Props = FooterProps['legal'] & {
  show: boolean | undefined;
  setShow: (show: boolean | undefined) => void;
  setConsent: (consent: boolean) => void;
};

const CookieBanner = ({
  show,
  setShow,
  setConsent,
  title,
  text,
  acceptButton,
  declineButton,
}: Props) => {
  const theme = useTheme();
  const onClose = (value: boolean) => {
    if (show) {
      setConsent(value);
      setShow(false);
    }
  };
  const t = useTranslate('legal.cookieBanner');
  return (
    <>
    <GlobalStyles styles={{
      '@keyframes cookieBannerSlideUp': {
        from: { transform: 'translateY(100%)' },
        to: { transform: 'translateY(0)' },
      },
    }} />
    <CookieConsent
      location="bottom"
      buttonText={acceptButton || t('okText')}
      declineButtonText={declineButton || t('declineText')}
      enableDeclineButton
      cookieName="cookie-consent"
      disableButtonStyles
      ButtonComponent={Button}
      onAccept={() => onClose(true)}
      onDecline={() => onClose(false)}
      visible={show === true ? 'show' : show === false ? 'byCookieValue' : 'hidden'}
      customButtonProps={{
        variant: 'contained',
        style: { margin: '0 10px' },
      }}
      customDeclineButtonProps={{
        variant: 'contained',
      }}
      style={{
        backgroundColor: theme.palette.background.paper,
        padding: '24px',
        animation: 'cookieBannerSlideUp 0.4s ease-out',
      }}
      expires={365}
    >
      <Stack spacing={2}>
        <Typography variant="h3">{title || t('title')}</Typography>
        {text ? (
          <RichText>{text}</RichText>
        ) : (
          <Typography
            sx={{
              '& a': {
                color: ({ palette }) =>
                  getContrastRatio(palette.primary.main, '#000') >
                  getContrastRatio(palette.secondary.main, '#000')
                    ? palette.primary.main
                    : palette.secondary.main,
              },
            }}
          >
            <RichI18n>{(tags) => t.rich('text', tags)}</RichI18n>
          </Typography>
        )}
      </Stack>
    </CookieConsent>
    </>
  );
};

export default CookieBanner;
